// Recurly rejects two concurrent reads of the same unique coupon code with SimultaneousRequestError,
// which surfaces as a 500 and a dead checkout page. Requests sharing a coupon run one at a time.
const queueByCoupon = new Map<string, Promise<unknown>>();

/**
 * Runs `request` after any earlier request for the same coupon code has settled. Requests with no
 * coupon, or with different coupons, still run concurrently.
 */
export function queueForCoupon<T>(couponCode: string | undefined, request: () => Promise<T>): Promise<T> {
  if (!couponCode) {
    return request();
  }

  const tail = queueByCoupon.get(couponCode) ?? Promise.resolve();
  const result = tail.then(request);
  // the stored tail swallows rejections so one failed request doesn't wedge the rest of the queue
  queueByCoupon.set(
    couponCode,
    result.catch(() => undefined),
  );

  return result;
}
